import { render, staticRenderFns } from "./FormFile.vue?vue&type=template&id=06eb183f&scoped=true"
import script from "./FormFile.vue?vue&type=script&lang=js"
export * from "./FormFile.vue?vue&type=script&lang=js"
import style0 from "./FormFile.vue?vue&type=style&index=0&id=06eb183f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06eb183f",
  null
  
)

export default component.exports